import { Text, View } from '@react-pdf/renderer';
import { type ReactElement } from 'react';
import { PDF_STYLES } from '../../styles';

interface FooterProps {
  generatedPrefix: string;
  generatedDate: string;
  contact: string;
  legal: string;
}

export const Footer = ({
  generatedPrefix,
  generatedDate,
  contact,
  legal,
}: FooterProps): ReactElement => (
  <View style={PDF_STYLES.footer}>
    <View style={PDF_STYLES.footerMeta}>
      <Text>
        <Text style={PDF_STYLES.footerMuted}>{generatedPrefix} </Text>
        <Text style={PDF_STYLES.footerDate}>{generatedDate}</Text>
      </Text>
      <Text style={PDF_STYLES.footerMuted}>{contact}</Text>
    </View>
    <View style={PDF_STYLES.footerLegalWrap}>
      <Text style={PDF_STYLES.footerLegal}>{legal}</Text>
    </View>
  </View>
);
